/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import Seo from "@components/seo"
import { AppContext } from "@src/context"
import classnames from "@src/utils/classnames"
import PropTypes from "prop-types"
import React, { useCallback, useEffect, useState } from "react"
import styles from "./index.module.scss"

const APP_BREAKPOINT = 800
const parseItem = item => {
  if (typeof item === "string") {
    return <img src={item} />
  }
  if (typeof item === "function") {
    return item()
  }
  return item
}

const Layout = ({ children, location }) => {
  const [isAppLayout, setIsAppLayout] = useState()
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    const resizeEvent = () => {
      const winWidth = window.document.documentElement.clientWidth
      const isApp = winWidth < APP_BREAKPOINT
      const htmlClassList = window.document.documentElement.classList
      if (isApp) {
        htmlClassList.add("is_app")
      } else {
        htmlClassList.remove("is_app")
      }
      htmlClassList.add("theme-disabled")
      setIsAppLayout(isApp)
      setInitialized(true)
    }
    resizeEvent()
    window.addEventListener("resize", resizeEvent)

    return () => {
      window.removeEventListener("resize", resizeEvent)
    }
  }, [])

  const renderItem = useCallback(
    (forPc, forApp) => {
      if (isAppLayout) {
        return parseItem(forApp)
      }
      return parseItem(forPc)
    },
    [isAppLayout]
  )

  const renderBanner = useCallback(
    (forPc, forApp, id) => {
      return (
        <div className={classnames(styles.banner, styles[`banner${id}`])}>
          <div className={styles.container}>{renderItem(forPc, forApp)}</div>
        </div>
      )
    },
    [renderItem]
  )

  if (!initialized) {
    return <div></div>
  }

  return (
    <AppContext.Provider
      value={{
        renderItem,
        renderBanner,
        parseItem,
        isAppLayout,
        APP_BREAKPOINT,
      }}
    >
      <Seo />
      <main>{children}</main>
    </AppContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
